module.exports = new __parcel__URL__("search-error.a6df7c97.svg").toString();